module.exports = __webpack_public_path__ + "static/fonts/CeraPro-Medium.c65c8b0.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/CeraPro-Medium.eot
// module id = KfrE
// module chunks = 1